import { render, staticRenderFns } from "./softwareStep02.vue?vue&type=template&id=30bb1d1c&"
import script from "./softwareStep02.vue?vue&type=script&lang=js&"
export * from "./softwareStep02.vue?vue&type=script&lang=js&"
import style0 from "./softwareStep02.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports